import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Accordion, Row, Col, KeyValue } from '@folio/stripes/components';

const DefaultLibraryInfo = ({
  accordionId,
  expanded,
  onToggle,
  user,
  getLibraryName,
}) => {
  const defaultLibraryId = user?.customFields?.defaultlibrary;

  return (
    <Accordion
      id={accordionId}
      open={expanded}
      onToggle={onToggle}
      label={<FormattedMessage id="ui-users.defaultLibrary.section.title" />}
    >
      <Row>
        <Col xs={12}>
          <KeyValue
            label={<FormattedMessage id="ui-users.defaultLibrary.library" />}
            value={
              defaultLibraryId ? (
                getLibraryName(defaultLibraryId)
              ) : (
                <FormattedMessage id="ui-users.defaultLibrary.notSet" />
              )
            }
          />
        </Col>
      </Row>
    </Accordion>
  );
};

DefaultLibraryInfo.propTypes = {
  accordionId: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  getLibraryName: PropTypes.func.isRequired,
};

export default DefaultLibraryInfo;
